import React, { useEffect, useState } from 'react';
import './MyReportsTranslate';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  confirmOrRejectAttendance, loadChildDdoDataReport,
  loadMyChildrenDataReport,
  loadMyChildrenList,
  myReportsModule,
  resetChildDataReport, resetHistoryDataReport
} from './MyReportsDucks';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import moment from 'moment';
import { StyledCardsContainer } from '../VoucherAppointments/VoucherAppointmentsStyle';
import ChildAttendanceCalendar from './ChildAttendenceCalendar';
import MyReportAttendanceRejectDialog from './MyReportAttendanceRejectDialog';
import { getDdoPeriodSuffix } from './MyReportsUtils';

function MyReports() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, childDdoData, childDataReport,isChildDataReportLoading } = useSelector(state => state[myReportsModule]);

  const [selectedChild, setSelectedChild] = useState('');
  const [selectedDate, setSelectedDate] = useState(moment().subtract(1, 'month'));
  const [selectedKindergarten, setSelectedKindergarten] = useState('');
  const selectedChildData = data.find(child => child.iin === selectedChild);

  useEffect(() => {
    dispatch(loadMyChildrenList());
  }, [dispatch]);

  const handleChildChange = (event) => {
    const iin = event.target.value;
    setSelectedChild(iin);
    setSelectedKindergarten('');
    dispatch(resetChildDataReport());
    dispatch(resetHistoryDataReport());

    if (iin) {
      dispatch(loadChildDdoDataReport({ iin }));
    }
  };

  const handleKindergartenChange = (event) => {
    // значение — id записи контингента (уникален для каждого периода зачисления),
    // а не serviceProviderId: при перезачислении в тот же сад id-провайдера совпадают
    const childRecordId = event.target.value;
    setSelectedKindergarten(childRecordId);
    dispatch(resetChildDataReport());
    dispatch(resetHistoryDataReport());

  };

  const handleConfirm = () => {
    if (!selectedKindergartenData) return;

    const childId = selectedKindergartenData.childId;
    const consentDate = moment().format('YYYY-MM-DD');
    const decisionMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const filterForReload = {
          dateMin: moment(selectedDate).startOf('month').format('YYYY-MM-DD'),
          dateMax: moment(selectedDate).endOf('month').format('YYYY-MM-DD'),
          pageNumber: 1,
          pageSize: 10,
          childId: selectedKindergarten,
          childIin: selectedChild,
          forQrRuntime: true
      };
    dispatch(
      confirmOrRejectAttendance(childId, consentDate,  true, decisionMonth,null, filterForReload )
    );
  };

  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);

  const handleRejectOpen = () => setIsRejectDialogOpen(true);
  const handleRejectClose = () => setIsRejectDialogOpen(false);

  const handleDoneForReject = async (denialReason) => {
    if (!selectedKindergartenData) return;

    const childId = selectedKindergartenData.childId;
    const consentDate = moment().format('YYYY-MM-DD');
    const decisionMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const filterForReload = {
          dateMin: moment(selectedDate).startOf('month').format('YYYY-MM-DD'),
          dateMax: moment(selectedDate).endOf('month').format('YYYY-MM-DD'),
          pageNumber: 1,
          pageSize: 10,
          childId: selectedKindergarten,
          childIin: selectedChild,
          forQrRuntime: true
      };
    try {
      setLoadingReject(true);
      await dispatch(
        confirmOrRejectAttendance(childId, consentDate, false, decisionMonth, denialReason,filterForReload)
      );
    } finally {
      setLoadingReject(false);
      handleRejectClose();
    }
  };

  const selectedKindergartenData = childDataReport.find(
    k => k.childId === selectedKindergarten
  );

  useEffect(() => {
    if (!selectedChild || !selectedKindergarten) return;

    const selectedKindergartenData = childDdoData.find(
      (item) => item.id === selectedKindergarten
    );
    if (!selectedKindergartenData) return;

    const startOfMonth = moment(selectedDate).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(selectedDate).endOf('month').format('YYYY-MM-DD');

    const filterParams = {
      dateMin: startOfMonth,
      dateMax: endOfMonth,
      pageNumber: 1,
      pageSize: 10,
      childId: selectedKindergartenData.id,
      childIin: selectedChild,
      forQrRuntime: true,
    };

    dispatch(loadMyChildrenDataReport(filterParams));
  }, [selectedDate, selectedChild, selectedKindergarten, childDdoData, dispatch]);



  return (
    <StyledCardsContainer>
      <div className="mt3">
        <h2>{t('myReports_title')}</h2>
      </div>

      <div style={{ display: 'flex', gap: '20px', width: '100%', flexWrap: 'wrap' }}>
        <FormControl variant="outlined" style={{ marginBottom: '20px', minWidth: 200 }}>
          <InputLabel id="child-select-label">{t('myReports_myChildren')}</InputLabel>
          <Select
            labelId="child-select-label"
            value={selectedChild}
            onChange={handleChildChange}
            label={t('myReports_myChildren')}
          >
            {data.length > 0 &&
              data.map(child => (
                <MenuItem key={child.iin} value={child.iin}>
                  {child.firstname} {child.lastname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" style={{ marginBottom: '20px', minWidth: 200 }}>
          <InputLabel id="kindergarten-select-label">{t('myReports_ddo')}</InputLabel>
          <Select
            labelId="kindergarten-select-label"
            value={selectedKindergarten}
            onChange={handleKindergartenChange}
            label={t('myReports_ddo')}
          >
            {childDdoData.length > 0 &&
              childDdoData.map(k => (
                <MenuItem key={k.id} value={k.id}>
                  {t('language') === 'kk'
                    ? k.serviceProviderKkName
                    : k.serviceProviderRuName}
                  {getDdoPeriodSuffix(k, childDdoData)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '0.4fr 0.6fr',
          gap: '20px',
          width: '100%',
          marginTop: '20px',
          alignItems: 'stretch'
        }}
      >
        <Paper
          elevation={1}
          style={{
            padding: '20px',
            borderRadius: '12px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            height: '100%'
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <PersonIcon style={{ fontSize: 60, marginRight: '20px' }} />
              {selectedChildData ? (
                <div>
                  <div><strong>{t('myReports_childSurname')}:</strong> {selectedChildData.lastname}</div>
                  <div><strong>{t('myReports_childName')}:</strong> {selectedChildData.firstname}</div>
                  <div><strong>{t('myReports_childBirthdayDate')}:</strong> {selectedChildData.birthday}</div>
                </div>
              ) : (
                <div style={{ color: '#888' }}>{t('myReports_noData')}</div>
              )}
            </div>

            <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}>
              <h4 style={{ marginBottom: '10px' }}>{t('myReports_infoDDO')}</h4>

              {selectedChild && selectedKindergarten ? (() => {
                const kindergartenInfo = childDdoData.find(
                  k => k.id === selectedKindergarten
                );
                if (!kindergartenInfo) return <div style={{ color: '#888' }}>{t('myReports_noData')}</div>;

                return (
                  <div>
                    <div>
                      <strong>{t('myReports_ddo')}:</strong>{' '}
                      {t('language') === 'kk'
                        ? kindergartenInfo.serviceProviderKkName
                        : kindergartenInfo.serviceProviderRuName}
                    </div>
                    <div>
                      <strong>{t('myReports_legalLocality')}:</strong> {kindergartenInfo.legalLocality}
                    </div>
                    <div>
                      <strong>{t('myReports_startDateAttempt')}:</strong> {moment(kindergartenInfo.enrolledDate).format('YYYY-MM-DD')}
                    </div>
                    {kindergartenInfo.expelledDate && (
                      <div>
                        <strong>{t('myReports_endDateAttempt')}:</strong> {moment(kindergartenInfo.expelledDate).format('YYYY-MM-DD')}
                      </div>
                    )}
                  </div>
                );
              })() : (
                <div style={{ color: '#888' }}>{t('myReports_noData')}</div>
              )}
            </div>
          </div>
        </Paper>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            height: '100%'
          }}
        >
          <Paper
            elevation={1}
            style={{
              padding: '20px',
              borderRadius: '12px',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <ChildAttendanceCalendar
                visitsInfo={
                  selectedKindergartenData?.visitsInfo
                    ? selectedKindergartenData.visitsInfo
                    : []
                }
                selectedDate={selectedDate}
                onMonthChange={setSelectedDate}
                noData={!selectedKindergartenData}
              />
            </div>
          </Paper>

          <Paper
            elevation={1}
            style={{
              padding: '20px',
              borderRadius: '12px',
              textAlign: 'center',
              minHeight: '100px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {!selectedKindergartenData ? (
              <div style={{ fontSize: '16px', color: '#999' }}>
                {t('myReports_noData')}
              </div>
            ) : isChildDataReportLoading ? (
              <div style={{ fontSize: '16px', color: '#777' }}>
                {t('myReportsCommon_loading')}
              </div>
            ) : (
              (() => {
                const currentMonth = moment().startOf('month');
                  const selectedIsCurrentMonth = moment(selectedDate).isSame(currentMonth, 'month');
                  const selectedIsPreviousMonth = moment(selectedDate).isSame(moment().subtract(1, 'month'), 'month');
                if (selectedKindergartenData.needConfirmation) {
                  if (selectedIsCurrentMonth) {
                    return (
                      <div style={{ fontSize: '16px', color: '#777' }}>
                        {t('myReports_availableConfirmDate')}
                      </div>
                    );
                  }

                  if (selectedIsPreviousMonth) {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '16px',
                          flexWrap: 'wrap'
                        }}
                      >
                        <button
                          onClick={handleConfirm}
                          style={{
                            backgroundColor: '#9b51e0',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px 24px',
                            cursor: 'pointer',
                            fontWeight: 500,
                            minWidth: '160px'
                          }}
                        >
                          {t('myReports_sign')}
                        </button>

                        <button
                          onClick={handleRejectOpen}
                          style={{
                            backgroundColor: '#f2f2f2',
                            color: '#333',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px 24px',
                            cursor: 'pointer',
                            fontWeight: 500,
                            minWidth: '160px'
                          }}
                        >
                          {t('myReports_reject')}
                        </button>
                      </div>
                    );
                  }

                  return (
                    <div style={{ fontSize: '16px', color: '#777' }}>
                      {t('myReports_availableConfirmDate')}
                    </div>
                  );
                }

                if (selectedKindergartenData.consentShortInfo) {
                  const { isConsentProvided } = selectedKindergartenData.consentShortInfo;
                  return (
                    <div style={{ fontSize: '16px', color: '#333' }}>
                      {isConsentProvided
                        ? t('myReports_signed')
                        : t('myReports_rejected')}
                    </div>
                  );
                }

                return (
                  <div style={{ fontSize: '16px', color: '#777' }}>
                    {t('myReports_availableConfirmDate')}
                  </div>
                );
              })()
            )}
          </Paper>
        </div>
      </div>

      <MyReportAttendanceRejectDialog
        open={isRejectDialogOpen}
        handleClose={handleRejectClose}
        handleDone={handleDoneForReject}
        loading={loadingReject}
      />
    </StyledCardsContainer>
  );
}

export default MyReports;
